import { Attributes } from 'lib/hooks/useWebConfig/useWebConfigAttributes'
import { getVariantKeyAndValue, getWebConfigActiveExperimentsVariants } from './webConfigExperiments'
import { WebsiteConfigFlag, WebsiteConfigFlagParams, websiteConfigFlags } from './webConfigFlags'

export type WebsiteConfig = {
    [x in WebsiteConfigFlagParams]?: boolean
}

let cachedWebsiteConfig: WebsiteConfig | null = null

export function getWebConfig(attributes: Attributes): WebsiteConfig | null {
    if (cachedWebsiteConfig) {
        return cachedWebsiteConfig
    }

    const websiteConfig = generateWebsiteConfig(attributes, websiteConfigFlags)
    cachedWebsiteConfig = websiteConfig

    return websiteConfig
}

const generateWebsiteConfig = (attributes: Attributes, configFlags: WebsiteConfigFlag[]) => {
    const websiteConfig: WebsiteConfig = {}

    const variants = getWebConfigActiveExperimentsVariants(attributes)

    configFlags.forEach((flag) => {
        if (!flag.isActive(attributes)) return

        const identifiers = Object.entries(flag.config)
        identifiers.forEach(([indentifier, value]) => {
            websiteConfig[indentifier as WebsiteConfigFlagParams] = value
        })
    })

    // Override flags with experiment variants
    variants.forEach((variant) => {
        const { identifier, value } = getVariantKeyAndValue(variant)

        websiteConfig[identifier as WebsiteConfigFlagParams] = value
    })

    return websiteConfig
}
